import React from 'react';

interface WeatherTrafficCamLoadingUIProps {
    isDetailPage?: boolean;
    isTrafficDetailPage?: boolean;
}

export const WeatherTrafficCamLoadingUI = ({ isDetailPage, isTrafficDetailPage }: WeatherTrafficCamLoadingUIProps): JSX.Element => {

    const generateCameraBoxes = (noOfCameraBoxes: number): JSX.Element => {
        const boxes = Array(noOfCameraBoxes).fill(null);
        return (
            <>
                {boxes.map(
                    (_, index) => 
                        <div className='camera-box' key={index}></div>
          
                )}
            </>
        );
    };

    return (
        <React.Fragment>
            <div className='camera-main-section-wrapper'>
                <div className={isDetailPage ? 'detail-page-main-container' : 'camera-main-section-container'}>
                    {isDetailPage ? <>
                        <div className='detail-page-header-wrapper'>
                            <div className='detail-page-header-text-container'>
                                <span className='detail-page-header-arrow-icon'>
                                    <svg width='14' height='14' viewBox='0 0 11 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M10.5912 2.225L9.10788 0.75L0.866211 9L9.11621 17.25L10.5912 15.775L3.81621 9L10.5912 2.225V2.225Z' fill='#ffffff'></path>
                                    </svg>
                                </span>
                                <div className='detail-page-header-text'>Back to Local Cameras</div>
                            </div>
                        </div>
                        <div className='detail-page-large-camera-label-container'>
                            <div className='detail-page-large-camera-label'>Camera Name</div>
                            <div className='detail-page-large-camera-label'>City, State</div>
                        </div>
                        <div className='detail-page-camera-large-container'>
                            <div className='detail-page-camera-large-container-content'></div>
                            <div className='detail-page-camera-map-and-ad-wrapper'>
                                <div className='detail-page-map-and-ad-container'>
                                    <div className='detail-page-map-conatiner'></div>
                                    <div style={{ width: 300, height: 250 }}></div>
                                </div>
                            </div>
                        </div>
                    </> : <>
                        <div className='camera-main-section-title'>Local Camera</div>
                        <div className='only-mobile'>
                            <div className='camera-main-section-grid-container'>
                                <div className='camera-main-section-large-view-container'></div>
                                {generateCameraBoxes(38)}
                            </div>
                        </div>
                        <div className='not-mobile'>
                            <div className='camera-main-section-grid-container'>
                                <div className='camera-main-section-large-view-container'></div>
                                {generateCameraBoxes(12)}
                            </div>
                            <div className='camera-main-section-ad-container'>
                                <div style={{ width: 728, height: 90 }}></div>
                            </div>
                            <div className='full-width-and-height camera-main-section-grid-container'>
                                {generateCameraBoxes(12)}
                            </div>
                            <div className='camera-main-section-ad-container'>
                                <div style={{ width: 728, height: 90 }}></div>
                            </div>
                            <div className='full-width-and-height camera-main-section-grid-container'>
                                {generateCameraBoxes(12)}
                            </div>
                            <div className='camera-main-section-ad-container'>
                                <div style={{ width: 728, height: 90 }}></div>
                            </div>
                        </div>
                    </>}
                    { !isTrafficDetailPage && <>
                        <div className='camera-main-section-category-title'>Featured Weather Cameras</div>
                        <div className='camera-main-section-category-container'>
                            {generateCameraBoxes(6)}
                        </div>
                        <div className='camera-main-section-category-title'>Weather Camera Categories</div>
                        <div className='camera-main-section-category-container'>
                            {generateCameraBoxes(6)}
                        </div>
                    </> }
                </div>
            </div>
        </React.Fragment>
    );
};